export class ICookieConsent {
  id?: number;
  uuid?: string | null;
  statistics?: boolean | null;
  customerId?: number | null;
  transporter?: number | null;

  constructor(data: any = {}) {
    Object.assign(this, data);
  }
}
